/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 * TODO: add more type and apply to code base
 * TODO: merge to transport queue
 * @format
 */

import { VCWireMsgType } from "./rdpvcbridge.const";

export enum RdpvcBridgeMsgType {
   WireMsgNone = 0,
   WireMsgThunk,
   WireMsgConnect,
   WireMsgDisconnect,
   WireMsgData,
   WireMsgSessionInfoQuery,
   WireMsgSessionInfoResponse,
   WireMsgMax
}

//TODO
export type VCWireMsg = any;

export type VCWireMsgHdr = {
   msgType: number;
   msgID: number;
   vcStreamID: number;
};

type DataFormat = Uint8Array | Array<number>;

class WireHeader {
   constructor(private msgType: VCWireMsgType) {}
   public getNewHeader = (vcStreamID) => {
      return {
         vcStreamID: vcStreamID,
         msgType: this.msgType,
         msgID: messageCounter++
      };
   };
}

class WirePayload {
   constructor(
      private payloadName: string,
      private queryMsgID: number,
      private channelName
   ) {}
   public getObject = (data: DataFormat) => {
      const payload = {};
      payload[this.payloadName] = {
         queryMsgID: this.queryMsgID,
         channelName: this.channelName,
         pData_OLD: 0,
         nBytes: data.length,
         paddingAlign: 0,
         pData: data
      };
      return payload;
   };
}

let messageCounter = 1;
abstract class WirePackage {
   protected wireHeader: WireHeader;
   protected wirePayload: WirePayload;
   constructor(payloadName: string, enumType: VCWireMsgType, channelName: string, queryMsgID: number = 0) {
      this.wireHeader = new WireHeader(enumType);
      this.wirePayload = new WirePayload(payloadName, queryMsgID, channelName);
   }
   protected getObject = (data: DataFormat, vcStreamId: number) => {
      return {
         header: this.wireHeader.getNewHeader(vcStreamId),
         payload: this.wirePayload.getObject(data)
      };
   };
}

export class SessionInfoResponse extends WirePackage {
   constructor(private queryHeader: VCWireMsgHdr) {
      super("sessionInfoResponse", VCWireMsgType.WireMsgSessionInfoResponse, "Internal", queryHeader.msgID);
   }
   public generateResponse = (data: DataFormat) => {
      const vcStreamId = this.queryHeader.vcStreamID;
      return this.getObject(data, vcStreamId);
   };
}

export class VCDataGenerator extends WirePackage {
   constructor(channelName: string) {
      super("data", VCWireMsgType.WireMsgData, channelName);
   }
   public generateNewData = (data: DataFormat, streamId: number) => {
      return this.getObject(data, streamId);
   };
}
